// Force page reload on browser back button navigation to prevent stale data
window.addEventListener("pageshow", function (event) {
  var historyTraversal = event.persisted ||
    (typeof window.performance != "undefined" &&
      window.performance.navigation.type === 2);
  if (historyTraversal) {
    window.location.reload();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function (event) {
    console.log('✅ [Bold Custom] BOLD LOADED SUCCESSFULLY');

    const errorModal = document.querySelector('#error-modal');
    const errorMax = errorModal ? errorModal.querySelector('#custom-max') : null;
    const swatches = document.querySelector('.bold_option_swatch');
    const manualEvent = new Event('change');
    const popupWrapper = document.querySelector('#selection-modal .choice-wrapper');
    const lollieSearch = document.querySelector('#lollie-search');
    const lollieNames = swatches ? swatches.querySelectorAll('.bold_option_value .bold_option_value_title') : [];
    const lollieSearchMessage = document.querySelector('#lollie-search-message');

    if (!swatches) return;

    function applyDataFilterAttribute() { /* Zadržano iz originala */ }

    function createOutOfStock() {
      lollieNames.forEach((lolly) => {
        if (lolly.textContent.includes('*')) {
          lolly.closest('.bold_option_value').classList.add('out-of-stock');
        }
      })
    }

    function createFilterElement(filters) { /* Zadržano iz originala */ }

    function applyFilter(filter) { /* Zadržano iz originala */ }

    function applySearchBar() {
      if (!lollieSearch) return;
      swatches.querySelector('.bold_option_element').insertBefore(lollieSearch.parentElement, swatches.querySelector('.bold_option_value'));
      lollieSearch.addEventListener('input', (e) => {
        setTimeout(() => { performSearch(e) }, 800)
      });
    }

    function performSearch(event) {
      let search = event.target.value.toUpperCase();
      let foundLollies = 0;
      for (let i = 0; i < lollieNames.length; i++) {
        if (lollieNames[i].textContent.toUpperCase().indexOf(search) > -1) {
          lollieNames[i].closest('.bold_option_value').style.display = '';
          foundLollies++;
        } else {
          lollieNames[i].closest('.bold_option_value').style.display = 'none';
        }
      }
      if (lollieSearchMessage) {
        if (foundLollies && search) {
          lollieSearchMessage.textContent = `Found ${foundLollies} Lollies that match your search!`
        } else if (!foundLollies && search) {
          lollieSearchMessage.textContent = "No Lollies found :( ."
        } else {
          lollieSearchMessage.textContent = "";
        }
      }
    }

    function extractName() {
      let swatchElements = swatches.querySelectorAll('.bold_option_value');
      swatchElements.forEach((element) => {
        element.querySelector('label').append(element.querySelector('.bold_option_value_title'));
        const swatchTitle = element.querySelector('.bold_option_swatch_title');
        if (swatchTitle) swatchTitle.remove();
      })
    }

    function getChoiceMax() {
      if (typeof window.max_lolly_choices !== 'undefined' && window.max_lolly_choices) {
        return window.max_lolly_choices;
      } else {
        const radioSelection = document.querySelector('.bold_option_radio input:checked');
        if (radioSelection) {
          return parseInt(radioSelection.value.split('(')[1].replace(/[^0-9]/g, ''));
        }
      }
      return 0;
    }

    function getChoiceCurrent() {
      let total = 0;
      let checkcedCheckboxes = document.querySelectorAll('.bold_option_swatch input[type="checkbox"]:checked');
      checkcedCheckboxes.forEach((checked) => {
        const qtyInput = checked.closest('label').nextElementSibling.querySelector('input');
        if (qtyInput) {
          total += parseInt(qtyInput.value) || 0;
        }
      })
      return total;
    }

    function createQuantityButtons(checkbox) {
      let quantityParent = checkbox.closest('label').nextElementSibling;
      if (!quantityParent) return;
      let inputElement = quantityParent.querySelector('input');
      if (inputElement) {
        if (quantityParent.querySelector('.quantity-increment')) return;
        let incrementButton = document.createElement('span');
        let decrementButton = document.createElement('span');
        incrementButton.textContent = '+';
        decrementButton.textContent = '-';
        incrementButton.classList.add('quantity-button', 'quantity-increment');
        decrementButton.classList.add('quantity-button', 'quantity-decrement');
        quantityParent.prepend(decrementButton);
        quantityParent.append(incrementButton);
        
        incrementButton.addEventListener('click', () => {
          inputElement.value = parseInt(inputElement.value) + 1;
          inputElement.dispatchEvent(manualEvent);
        })
        decrementButton.addEventListener('click', () => {
          if (inputElement.value != 0) {
            inputElement.value -= 1;
            inputElement.dispatchEvent(manualEvent);
          }
        })
        inputElement.setAttribute('disabled', 'disabled');
      } else {
        if (quantityParent.children.length > 0) quantityParent.replaceChildren();
      }
    }

    // --- REŠENJE ZA BLOKIRANJE ADD TO CART DUGMETA ---
    function userFeedback(max, current, displayError) {
      if (displayError && errorModal && errorMax) {
        errorMax.textContent = max;
        errorModal.style.display = "flex";
        setTimeout(() => { errorModal.style.opacity = "1" }, 300);
        setTimeout(() => { errorModal.style.opacity = "0" }, 3600);
        setTimeout(() => { errorModal.style.display = "none" }, 4000);
      }
      
      const optionStatus = document.querySelector('#option-status');
      if (optionStatus) {
        if (current && !displayError) {
          document.querySelectorAll('.status-min').forEach((span) => { span.textContent = current });
          document.querySelectorAll('.status-max').forEach((span) => { span.textContent = max });
          optionStatus.style.transform = "translateY(0)";
        } else if (current == 0) {
          optionStatus.style.transform = "translateY(100%)";
          document.querySelectorAll('.status-min').forEach((span) => { span.textContent = current });
          document.querySelectorAll('.status-max').forEach((span) => { span.textContent = max });
        }
      }

      // Zaključavanje glavnog Add To Cart dugmeta na novoj temi
      const themeAtcButtons = document.querySelectorAll('.add-to-cart-btn.bold_clone');
      
      if (max > 0 && current === max) {
        // Omogući korpu jer je uslov ispunjen
        document.querySelectorAll('.custom-cart').forEach((cart) => { cart.style.display = "inline-block" });
        themeAtcButtons.forEach(btn => {
            btn.removeAttribute('disabled');
            btn.classList.remove('cursor-not-allowed');
            btn.style.pointerEvents = 'auto'; // Vraća klikabilnost
            btn.style.opacity = '1';
            let textSpan = btn.querySelector('span[x-text="addToCartText"]');
            if(textSpan) textSpan.textContent = 'Add to Cart';
        });
      } else {
        // Blokiraj korpu jer uslov NIJE ispunjen
        document.querySelectorAll('.custom-cart').forEach((cart) => { cart.style.display = "none" });
        themeAtcButtons.forEach(btn => {
            btn.setAttribute('disabled', 'disabled');
            btn.classList.add('cursor-not-allowed');
            btn.style.pointerEvents = 'none'; // Force block against Alpine.js clicks
            btn.style.opacity = '0.5';
            
            let remaining = max - current;
            let textSpan = btn.querySelector('span[x-text="addToCartText"]');
            if(textSpan && max > 0 && remaining > 0) {
              textSpan.textContent = `Select ${remaining} more lollies`;
            }
        });
      }
    }

    function handlePopUp() {
      const animation = [{ top: "2px" }, { top: "10px" }];
      const animationParams = { duration: 100, iterations: 1 }
      const popupBtn = document.querySelector('.floating-option.floating-button');
      const popup = document.querySelector('#selection-modal');
      if (!popupBtn || !popup) return;

      const config = { characterData: false, attributes: false, childList: true, subtree: false };
      function mutate(mutations) {
        mutations.forEach((mutation) => {
          popupBtn.parentElement.animate(animation, animationParams);
        })
      }
      const observer = new MutationObserver(mutate);
      observer.observe(popupBtn, config);
      
      popupBtn.addEventListener('click', () => {
        populatePopup();
        popup.style.display = "flex";
        setTimeout(() => { popup.style.opacity = "1" }, 300);
      })
      popup.addEventListener('click', (event) => {
        if (event.target === popup) {
          popup.style.display = "none";
          if (popupWrapper) popupWrapper.replaceChildren();
        }
      })
    }

    function populatePopup() {
      if (!popupWrapper) return;
      let inputs = swatches.querySelectorAll('input[type="checkbox"]:checked');
      inputs.forEach((input) => {
        let inputParent = input.closest('.bold_option_value');
        popupWrapper.appendChild(inputParent.cloneNode(true));
      })
      popupWrapper.querySelectorAll('.quantity-button').forEach((button) => {
        button.addEventListener('click', (e) => {
          let clickedElementValue = e.target.parentElement.parentElement.querySelector('input[type="checkbox"]').value;
          if (e.target.textContent === "+") {
            swatches.querySelector(`.bold_option_value:has(input[value="${clickedElementValue}"]) .quantity-increment`).click();
          } else if (e.target.textContent === "-") {
            swatches.querySelector(`.bold_option_value:has(input[value="${clickedElementValue}"]) .quantity-decrement`).click();
          }
          setTimeout(() => {
            popupWrapper.replaceChildren();
            populatePopup();
          }, 600)
        })
      })
      popupWrapper.addEventListener('change', (e) => {
        e.stopImmediatePropagation();
        if (e.target.type === "checkbox") {
          let originalCheckbox = document.querySelector(`.bold_options_loaded input[value="${e.target.value}"]`);
          if (originalCheckbox) {
            let boldUiSwatch = originalCheckbox.closest('.bold_option_value').querySelector('.bold_option_value_element');
            if (boldUiSwatch) boldUiSwatch.click();
            else originalCheckbox.click();
          }
          e.stopPropagation();
          e.target.closest('.bold_option_value').remove();
        } else if (e.target.type === "number") {
          let boldInput = document.querySelector(`.bold_options_loaded input.${e.target.classList[0]}`);
          if (boldInput) {
            boldInput.value = e.target.value;
            boldInput.dispatchEvent(manualEvent);
          }
        }
      })
    }

    // --- REŠENJE ZA INFINITE LOOP BAGA ---
    let isReverting = false; // "Brava" koja sprečava Bold da uđe u infinite loop

    function handleChangeEvent(event) {
      if (event.target && !event.target.matches('input')) return;
      if (event.target.classList.contains('custom-filter')) {
        applyFilter(event.target.value);
        return;
      }

      if (isReverting) {
        console.log('🔒 [Bold Custom] Ignoring event, currently reverting an over-limit selection.');
        return;
      }

      setTimeout(() => {
        let maxChoices = getChoiceMax();
        let currentChoices = getChoiceCurrent();
        let eventType = event.target.type;

        console.log(`📊 [Bold Custom] Current Choices: ${currentChoices} / Max: ${maxChoices}`);

        // Ubica infinite loop-a:
        if (currentChoices > maxChoices && (eventType === 'checkbox' || eventType === 'number')) {
          console.log('🛑 [Bold Custom] Limit exceeded! Triggering revert block.');
          isReverting = true;

          if (eventType === 'checkbox') {
            // Nasilno odčekiraj bez oslanjanja na UI click
            event.target.checked = false;
            let uiSwatch = event.target.closest('.bold_option_value').querySelector('.bold_option_value_element');
            if (uiSwatch) {
              uiSwatch.classList.remove('bold_swatch_selected');
              uiSwatch.setAttribute('aria-checked', 'false');
            }
            // Okini event da Bold zna da je sklonjeno (ali će naš skript to ignorisati zbog isReverting brave)
            event.target.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (eventType === 'number') {
            event.target.value = event.target.value - (currentChoices - maxChoices);
            event.target.dispatchEvent(manualEvent);
          }

          userFeedback(maxChoices, currentChoices - 1, true); // Prikaži error popup
          
          setTimeout(() => { 
            isReverting = false; 
            console.log('🔓 [Bold Custom] Revert lock released.');
          }, 300); // 300ms je dovoljno da ugasi loop
          
          return; 
        }

        // Normalno procesuiranje ako smo ispod ili na limitu
        if (eventType === "radio") {
          handleRadioEvent(event.target, maxChoices, currentChoices);
        } else if (eventType === "checkbox") {
          createQuantityButtons(event.target);
        }
        
        userFeedback(maxChoices, currentChoices, false);
      }, 50);
    }

    function handleRadioEvent(radio, max, current) {
      if (current > max) {
        let selectedSwatches = swatches.querySelectorAll('input:checked');
        selectedSwatches.forEach((swatch) => { 
          let boldUiSwatch = swatch.closest('.bold_option_value').querySelector('.bold_option_value_element');
          if (boldUiSwatch) boldUiSwatch.click();
          else swatch.click();
        });
      }
      try {
        document.querySelector(`#ProductThumbs img[alt="${radio.value}"]`).click();
      } catch (e) {}
    }

    function addActiveClassOnLoad() {
      document.querySelector('.bold_option_radio input:checked')?.closest('label')?.querySelector('.bold_option_value_title').classList.add('active');
    }

    const optionSet = document.querySelector('.bold_option_set');
    if (optionSet) {
      optionSet.addEventListener('change', handleChangeEvent, true);
    }
    
    extractName();
    handlePopUp();
    applySearchBar();
    createOutOfStock();
    userFeedback(getChoiceMax(), getChoiceCurrent(), false);
    
    if (document.querySelector('.bold_option_radio')){
      setTimeout(() => {
        let radioElements = document.querySelectorAll('.bold_option_radio .bold_option_value label .bold_option_value_element input');
        if (radioElements.length >= 2) {
          radioElements[1].click();
          radioElements[0].click();
          radioElements[1].click();
          radioElements[0].click();
          addActiveClassOnLoad();
        }
      }, 2500)
    }
    
    document.addEventListener('keypress', (e) => {
      if (e.keyCode == 13) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
      }
    })
  })
})